/* --------------------------------------------------------------------------
   UF SURVEY RESULTS

   Two jobs: count the headline figures up when they come into view, and cycle
   the testimonials.

   ITS OWN BIND FLAG. The cards section once inherited uf-benefits' flag and
   silently did nothing on any page running both, so every script here gets a
   name of its own.

   FAILS OPEN, ALWAYS. Every path that could leave a figure showing "0%" or a
   carousel showing nothing instead resolves to the final state. A wrong number
   on a page of statistics is far worse than a missing animation.
-------------------------------------------------------------------------- */
(function () {
  if (window.__ufSurveyBound) return;
  window.__ufSurveyBound = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ count-up */

  /* Splits "84%" into prefix / number / suffix so the animation only touches
     the digits. Anything without a number in it — "9 in 10", a word — returns
     null and is left exactly as authored rather than mangled. */
  /* Re-inserts thousands separators as the number climbs, so a figure
     authored as "1,500+" counts 0 → 1,500 and not 0 → 1500. */
  function group(s) {
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function parseFigure(text) {
    /* The digit run may contain commas. Without this the match fails outright
       on a grouped figure — \d+ cannot cross the comma, and the trailing \D*
       cannot swallow the digits after it — so the figure silently never
       animated. Ungrouped figures like "97%" parse exactly as before, which is
       what keeps CALM's two cards behaving identically. */
    var m = String(text).match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(\D*)$/);
    if (!m) return null;
    var digits = m[2].replace(/,/g, '');
    if (!digits) return null;
    return {
      prefix: m[1],
      value: parseFloat(digits),
      suffix: m[3],
      decimals: (digits.split('.')[1] || '').length,
      grouped: m[2].indexOf(',') !== -1,
    };
  }

  function countUp(el) {
    if (el.dataset.ufCounted) return;
    el.dataset.ufCounted = '1';

    var parsed = parseFigure(el.textContent.trim());
    if (!parsed || REDUCED) return;

    /* RESERVE THE FINAL WIDTH BEFORE THE FIRST FRAME OVERWRITES THE TEXT.
       The figure sizes itself to its content, so counting 0 -> 1,500 grows the
       box by three characters and shoves the divider and the label along with
       it. The CSS floor below this (3.4ch) was cut for a three-character
       figure like "97%" and does nothing for a six-character one.

       Measured here, while the element still holds the authored value, so the
       number grows into a box that is already the size it will end up — and
       everything beside it stays put. Cleared on completion so the element
       goes back to sizing itself and a later resize is not stuck at a px
       width measured at some other viewport. */
    var reserved = el.getBoundingClientRect().width;
    if (reserved > 0) el.style.minWidth = reserved + 'px';

    var DURATION = 1100;
    var start = null;
    var render = function (v) {
      var s = v.toFixed(parsed.decimals);
      el.textContent = parsed.prefix + (parsed.grouped ? group(s) : s) + parsed.suffix;
    };

    render(0);

    function frame(now) {
      if (start === null) start = now;
      var t = Math.min((now - start) / DURATION, 1);
      /* Ease-out cubic: fast at the start, settling onto the real number
         rather than crawling the last few digits. */
      var eased = 1 - Math.pow(1 - t, 3);
      render(parsed.value * eased);
      if (t < 1) requestAnimationFrame(frame);
      else {
        render(parsed.value);
        el.style.minWidth = '';
      }
    }

    requestAnimationFrame(frame);
  }

  function initCounters(root) {
    var figures = (root || document).querySelectorAll('.uf-survey__figure, .uf-survey__panel-figure');
    if (!figures.length) return;

    if (!('IntersectionObserver' in window)) {
      return; /* Values are already in the DOM — leave them. */
    }

    /* A working observer always delivers one callback per observed element on
       the next frame, intersecting or not. Where it never does, the observer
       is inert and the figures simply stay as authored. */
    var alive = false;
    var io = new IntersectionObserver(
      function (entries) {
        alive = true;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    Array.prototype.forEach.call(figures, function (el) {
      io.observe(el);
    });

    setTimeout(function () {
      if (!alive) io.disconnect();
    }, 2000);
  }

  /* ----------------------------------------------------------- carousel */

  function initCarousel(root) {
    var wraps = (root || document).querySelectorAll('.uf-survey__quotes');

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.ufReady) return;
      wrap.dataset.ufReady = '1';

      var slides = wrap.querySelectorAll('.uf-survey__quote');
      var dots = wrap.parentNode.querySelectorAll('.uf-survey__dot-btn');
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var delay = parseInt(wrap.dataset.interval, 10) || 6000;

      function show(next) {
        index = (next + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (s, i) {
          var on = i === index;
          s.classList.toggle('is-active', on);
          /* inert rather than merely transparent: a faded-out quote must not
             be readable by a screen reader or reachable by Tab. */
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        Array.prototype.forEach.call(dots, function (d, i) {
          var on = i === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      function play() {
        if (REDUCED || wrap.dataset.autoplay !== 'true') return;
        stop();
        timer = setInterval(function () { show(index + 1); }, delay);
      }

      Array.prototype.forEach.call(dots, function (d, i) {
        d.addEventListener('click', function () { show(i); stop(); play(); });
      });

      /* Anyone reading has stopped scrolling — do not move the text out from
         under them. */
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', play);
      wrap.addEventListener('focusin', stop);
      wrap.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else play();
      });

      show(0);
      play();
    });
  }

  function init(root) {
    initCounters(root);
    initCarousel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* The theme editor rebuilds a section's markup in place, which would leave
     the new nodes unbound. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
